<template>
  <div class="wp_filterTabMenuConatiner">
    <div class="cd-tab-filter">
      <div class="row filterandsort m-0">
							<div class="col-0 col-md-7 col-lg-9">
								<bread-crumb :productsLength="productsLength"/>
							</div>
							<filter-button/>
							<sort-menu/>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from '../../../widgets/breadcrumb/BreadCrumb'
import SortMenu from '../sort/SortMenu'
import FilterButton from './FilterButton'

export default {
	name: 'product-listing-top-panel',
	components: {
		FilterButton,
		SortMenu,
		BreadCrumb
	},
	props: {
		productsLength: Number
	}
}
</script>
